// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from '../NoDataCell';
import { formatMessage } from '@/utils/i18n';
import { ESGRatingClassification, ESGColourDefinition } from '@/enums/Esg';
import ComparisonItem from '@/types/comparison-item';
import DisclaimerInfos from '@/types/disclaimer-infos';
import Locale from '@/types/locale';

type Props = {
  value?: ESGRatingClassification;
  className?: string;
  item?: ComparisonItem;
  disclaimer?: string;
  onClick?: () => void;
  id?: string;
  valueDisclaimer?: DisclaimerInfos;
  hasDisclaimer?: boolean;
  locale?: Locale;
};

const ClassificationCell: React.FunctionComponent<Props> = ({
  value,
  className,
  disclaimer,
  valueDisclaimer,
  item,
  onClick,
  id,
  hasDisclaimer,
  locale,
}: Props) => {
  if (value == null) {
    return <NoDataCell disclaimerKey={disclaimer} item={item} onClick={onClick} id={id} locale={locale} />;
  }

  let esgRatingColor;

  if (value === ESGRatingClassification.LEADER) {
    esgRatingColor = ESGColourDefinition.TEXT_ALIGNED;
  }

  if (value === ESGRatingClassification.AVERAGE) {
    esgRatingColor = ESGColourDefinition.TEXT_MODERATE;
  }

  if (value === ESGRatingClassification.LAGGARD) {
    esgRatingColor = ESGColourDefinition.TEXT_STRONGLY_MISALIGNED;
  }

  return (
    <div className={classNames(className, 'cell esg-rating-cell')} id={id ? `cell-${id}` : undefined} style={{ color: esgRatingColor }} onClick={onClick}>
      <span className="markup-container">{formatMessage(`ESGComparisonTool.Rating.Classification.${value}`)}</span>
    </div>
  );
};

export default ClassificationCell;
